import { createAsyncAction } from "typesafe-actions";

import { Page } from "../../lib/model/Page";
import { Order } from "../../lib/model/Order";
import { OrdersFilter } from "../../lib/model/OrdersFilter";

export const fetchOrdersAsync = createAsyncAction(
  "orders/FETCH_ORDERS_REQUEST",
  "orders/FETCH_ORDERS_SUCCESS",
  "orders/FETCH_ORDERS_FAILURE"
)<{filter: OrdersFilter, after?: string}, Page<Order>, Error>();

export const searchOrdersAsync = createAsyncAction(
  "orders/SEARCH_ORDERS_REQUEST",
  "orders/SEARCH_ORDERS_SUCCESS",
  "orders/SEARCH_ORDERS_FAILURE",
)<string, Order[], Error>();